import { useState } from "react";
import moment from "moment";
import { Formik, Form } from "formik";
import DetailModal from "../../../../Components/DetailModal";
import { GiveSubscription } from "../../../../Api/clientUser";
import SaveButton from "../../../../Components/SaveButton";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";

const SubscriptionForm = ({ user, onClose, openModal, refetch, yearlyPrice, monthlyPrice, fetchSubscription = () => { } }) => {
    const startDate = moment().format("YYYY-MM-DD");
    const [loading, setLoading] = useState(false);

    const getEndDate = (plan) =>
        plan === "monthly"
            ? moment(startDate).add(1, "month").format("YYYY-MM-DD")
            : moment(startDate).add(1, "year").format("YYYY-MM-DD");

    const getPrice = (plan) => (plan === "monthly" ? monthlyPrice : yearlyPrice);

    const handleSubmit = async (values) => {
        setLoading(true);
        const payload = {
            userId: user?._id,
            type: values.plan,
        };
        try {
            const res = await GiveSubscription(payload);
            if (res?.status === 1) {
                refetch();
                fetchSubscription();
                SuccessToast(res?.message || "Subscription apply successfully.")
                setLoading(false);
                onClose();
            } else {
                setLoading(false);
            }
        } catch (error) {
            ErrorToast(error?.response?.data?.message || "Server Error.");
            setLoading(false);
        }
    };

    return (
        <DetailModal
            title="Give Subscription"
            show={openModal}
            onClose={onClose}
            size="md"
            className="subscriptionForm-modal"
        >
            <Formik
                initialValues={{ plan: "monthly" }}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <div className="detail-list">
                            <div className="row align-items-center mb-1">
                                <div className="col-12">
                                    <div className="modal-label mb-1">Plan Type</div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center col-6 pl-0 gap-2">
                                            <button
                                                type="button"
                                                className={`subscription-form-modal-btn ${values.plan === "monthly" ? "subscription-form-modal-apply" : ""}`}
                                                onClick={() => setFieldValue("plan", "monthly")}
                                            >
                                                Monthly
                                            </button>
                                            <button
                                                type="button"
                                                className={`subscription-form-modal-btn ${values.plan === "yearly" ? "subscription-form-modal-apply" : ""}`}
                                                onClick={() => setFieldValue("plan", "yearly")}
                                            >
                                                Yearly
                                            </button>
                                        </div>

                                        <div className="col-6">
                                            <span className="fs-5">£{getPrice(values.plan)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row align-items-center mb-2">
                                <div className="col-6">
                                    <div className="modal-label mb-1">Start Date</div>
                                    <div className="modal-value content-text fs-5">{startDate}</div>
                                </div>
                                <div className="col-6">
                                    <div className="modal-label mb-1">End Date</div>
                                    <div className="modal-value content-text fs-5">
                                        {getEndDate(values.plan)}
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className={`add-button subscription-form-modal-btn subscription-form-modal-close ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <SaveButton
                                    extraClassName="subscription-form-modal-btn subscription-form-modal-apply"
                                    loading={loading}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </DetailModal>
    );
};

export default SubscriptionForm;
